import { conf } from '../../configService';
import { dateService } from '../../dateService';
import { organizationType } from './organizationType';
import { imageObjectType } from './imageObjectType';
import {
  getContentModificationDate,
  getContentPublishDate
} from '../../../utils/contentUtils';
import { removeEmptyProperties } from '../../../utils/objectUtils';

// @see https://schema.org/ImageGallery
export const imageGalleryType = content => {
  const imageEntity = content.images?.[0]?.entity || content.data?.[0]?.image;
  return removeEmptyProperties({
    '@type': 'ImageGallery',
    '@id': `https://${conf.canonicalDomain}${content.url?.path}`,
    name: content.title,
    url: `https://${conf.canonicalDomain}${content.url?.path}`,
    datePublished: dateService.format(
      getContentPublishDate(content) * 1000,
      'iso-no-milliseconds'
    ),
    dateModified: dateService.format(
      getContentModificationDate(content) * 1000,
      'iso-no-milliseconds'
    ),
    publisher: organizationType(),
    primaryImageOfPage: imageObjectType(imageEntity),
    keywords: content.metaTags?.keywords
  });
};
